import Vue from 'vue';
import apiPlugin from '../service/api/vuePlugin';
 
Vue.use(apiPlugin);